import { Reveal, Overline } from "@/components/Kinetic";
import { useLang } from "@/i18n/LanguageContext";

export default function LegalPage({ content, testid }) {
  const { lang } = useLang();
  const c = content[lang] || content.en;


  return (
    <section className="bg-paper pt-32 sm:pt-40 lg:pt-44">
      <div className="mx-auto max-w-7xl px-4 pb-20 sm:px-6 sm:pb-28 lg:px-8">
        <Reveal immediate y={16}>
          <Overline>{c.overline}</Overline>
        </Reveal>
        <Reveal immediate delay={0.1} y={20}>
          <h1
            data-testid={`${testid}-title`}
            className="mt-7 max-w-3xl font-display text-4xl font-bold leading-[1.06] tracking-tight text-ink sm:text-5xl"
          >
            {c.title}
          </h1>
        </Reveal>
        <Reveal immediate delay={0.2} y={20}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
            {c.intro}
          </p>
        </Reveal>
        <div className="mt-14 border-t border-slate-200">
          {c.chapters.map((ch, i) => (
            <Reveal key={ch.title} delay={Math.min(i * 0.05, 0.3)} y={18}>
              <div
                data-testid={`${testid}-chapter-${i + 1}`}
                className="grid grid-cols-[auto_1fr] gap-6 border-b border-slate-200 py-7 sm:gap-10"
              >
                <span className="pt-1 font-mono text-xs tracking-[0.15em] text-slate-400">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="font-display text-lg font-bold tracking-tight text-ink sm:text-xl">
                    {ch.title}
                  </h2>
                  <p className="mt-2.5 max-w-2xl text-sm leading-relaxed text-slate-600">
                    {ch.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
            {c.footnote}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
